import { Calendar, MapPin, Ticket, Users } from "lucide-react";
import Reveal from "./Reveal";
import CtaButton from "./CtaButton";
import RegisterButton from "./RegisterButton";

const INFO = [
    { icon: Ticket, text: "FREE ENTRY" },
    { icon: MapPin, text: "CONNEXION BANGSAR" },
    { icon: Calendar, text: "31 OCTOBER 2026" },
    { icon: Users, text: "LIMITED TO 100 PAX" },
];

const FinalCTA = () => (
    <section
        data-testid="final-cta-section"
        className="relative overflow-hidden border-y border-white/5 bg-white/[0.02] py-24 md:py-32"
    >
        <div className="pointer-events-none absolute -left-32 bottom-0 h-[420px] w-[420px] rounded-full bg-blood/15 blur-3xl" />
        <div className="pointer-events-none absolute -right-32 top-0 h-[420px] w-[420px] rounded-full bg-volt/15 blur-3xl" />
        <svg
            viewBox="0 0 80 48"
            aria-hidden="true"
            className="pointer-events-none absolute left-1/2 top-1/2 h-[260px] -translate-x-1/2 -translate-y-1/2 opacity-[0.05]"
        >
            <rect x="6" y="16" width="8" height="18" rx="2" fill="#E31B23" />
            <rect x="26" y="10" width="8" height="26" rx="2" fill="#1677FF" />
            <rect x="46" y="4" width="10" height="36" rx="2" fill="#E9EAEF" />
            <rect x="66" y="12" width="8" height="20" rx="2" fill="#1677FF" />
        </svg>

        <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
            <Reveal>
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-flame">
                    Jom sertai kami
                </p>
                <h2 className="mt-5 font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-7xl">
                    KL, ARE YOU{" "}
                    <span className="text-chrome-grad">READY?</span> 🔥
                </h2>
                <p className="mx-auto mt-6 max-w-2xl leading-relaxed text-white/70">
                    Satu hari untuk tambah ilmu, memahami teknik Engulfing dan
                    berjumpa dengan komuniti trader secara face-to-face.
                </p>
            </Reveal>

            <Reveal delay={0.1}>
                <div className="mx-auto mt-10 grid max-w-xl grid-cols-2 gap-3">
                    {INFO.map((c, i) => (
                        <div
                            key={c.text}
                            data-testid={`final-info-${i + 1}`}
                            className="glass flex items-center gap-3 rounded-2xl px-4 py-3.5 text-left"
                        >
                            <c.icon size={16} className="shrink-0 text-white/85" />
                            <span className="font-mono text-[11px] uppercase tracking-[0.14em] text-white/85">
                                {c.text}
                            </span>
                        </div>
                    ))}
                </div>
            </Reveal>

            <Reveal delay={0.15}>
                <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:flex-wrap">
                    <CtaButton location="Final" testId="final-cta-button">
                        🚀 PM Admin &amp; Book My Seat
                    </CtaButton>
                    <RegisterButton testId="final-register-button" />
                </div>
                <p className="mt-6 text-xs italic text-white/40">
                    *Seat tertakluk kepada ketersediaan dan pengesahan
                    pendaftaran oleh admin.*
                </p>
            </Reveal>
        </div>
    </section>
);

export default FinalCTA;
